import React from 'react';
import { LoginMetamask } from '../components/LoginMetamask'; // Adjust path
import { PageLayout } from '../components/PageElements';
import { useParams, Link } from 'react-router-dom';
import { FeaturePanel } from '../components/FeaturePanel';

export const FeaturePage = ({config}) => {
  const { featureId } = useParams();
  return (
    <>
      <div className="p-6 flex flex-col items-start">
        <Link to="/dashboard" className="mt-4 text-white underline mb-2">
          &lt; Back to Dashboard
        </Link>
        <FeaturePanel featureId={featureId} apiBaseUrl={config.apiBaseUrl} />
      </div>
    </>
  );
};